<app-base-entry-dialog-template [value]="value" [formGroupRef]="formGroupRef" [isSaving]="isSaving"
                                (saveClick)="onSaveClicked()" (cancelClick)="onCancelClicked()">
  <app-transaction-form
    *ngIf="value"
    [(formGroupRef)]="formGroupRef"
    [(value)]="value">
  </app-transaction-form>
</app-base-entry-dialog-template>
